// extracted by mini-css-extract-plugin
export default {"knowAbout":"Occassion_knowAbout__76T09","knowAbout__ul":"Occassion_knowAbout__ul__PMegX","knowAbout__ul__li":"Occassion_knowAbout__ul__li__V452a"};